const updateElementState = (element, shouldShow) => {
    element.stop(true, true)
        .toggleClass('row_hidden', !shouldShow)
        .toggleClass('row_visible', shouldShow)
        .find('input, select')
        .not('[data-prevent-required="false"]')
        .toggleClass('required', shouldShow)
        .attr('required', shouldShow)
        .parent('div')
        .toggleClass('required', shouldShow);
};

const toggleVisibility = (checkbox, poBoxSelector, addressSelector) => {
    const isChecked = checkbox.is(':checked');
    updateElementState($(poBoxSelector), isChecked);
    updateElementState($(addressSelector), !isChecked);
};

export { toggleVisibility };
